/**
 * Cookie 工具函数
 */
const CookieUtil = {
    set: function (name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },

    get: function (name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    erase: function (name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }
};

/**
 * youtube player 
 */
class YouTubePlayer {
    constructor(playerElement, videoId, options = {}) {
        this.youtubeUrl = 'https://www.youtube.com/iframe_api'
        this.playerElement = playerElement;
        this.videoId = videoId;
        this.options = options;
        this.player = null;

        this.initPlayer()
    }

    /**
     * 初始化YouTube的script
     * @param callback
     */
    initPlayer() {
        this.initYouTubeScript(function () {
            if (typeof TY == 'undefined' || typeof YT.Player === 'undefined') {
                if (!window.youtubeIframeAPIReady) {
                    window.youtubeIframeAPIReady = new Promise((resolve) => {
                        window.onYouTubeIframeAPIReady = () => {
                            resolve();
                        };
                    });
                }
                window.youtubeIframeAPIReady.then(() => {
                    this.createPlayer();
                });
            } else {
                this.createPlayer();
            }
        }.bind(this))
    }

    createPlayer() {
        this.player = new YT.Player(this.playerElement, {
            height: this.options.height || '360',
            width: this.options.width || '640',
            suggestedQuality: this.options.suggestedQuality || 'default',
            videoId: this.videoId,
            events: {
                'onReady': this.onPlayerReady.bind(this),
                'onStateChange': this.onPlayerStateChange.bind(this)
            }
        });
    }


    /**
     * Initialize YouTube script
     * @param {Function} func
     */
    initYouTubeScript(func) {
        if (window.youtubeScriptLoaded) {
            func()
            return
        }
        const scripts = document.getElementsByTagName('script');
        let isLoaded = false
        Array.from(scripts).forEach(script => {
            if (script.src.includes(this.youtubeUrl)) {
                isLoaded = true
            }
        });

        if (!isLoaded) {
            const youtubeScript = document.createElement('script');
            youtubeScript.src = this.youtubeUrl;
            document.getElementsByTagName('head')[0].appendChild(youtubeScript);
            window.youtubeScriptLoaded = true;
            func()
        }
    }


    onPlayerReady(event) {
        if (this.options.onReady) {
            this.options.onReady(event);
        }
    }

    onPlayerStateChange(event) {
        if (this.options.onStateChange) {
            this.options.onStateChange(event);
        }
    }

    play() {
        if (this.player) {
            this.player.playVideo();
        }
    }

    pause() {
        if (this.player) {
            this.player.pauseVideo();
        }
    }

    stop() {
        if (this.player) {
            this.player.stopVideo();
        }
    }

    seekTo(seconds, allowSeekAhead = true) {
        if (this.player) {
            this.player.seekTo(seconds, allowSeekAhead);
        }
    }

    loadVideoById(videoId) {
        if (this.player) {
            this.videoId = videoId;
            this.player.loadVideoById(videoId);
            this.stop()
        }
    }
}


/**
 * 工具函数类
 */
class WeUtil {

    /**
     * 获取滚动条宽度
     * @returns 
     */
    getScrollbarWidth() {
        const container = document.createElement('div');
        document.body.appendChild(container);
        container.style.overflow = 'scroll';
        const inner = document.createElement('div');
        container.appendChild(inner);
        const scrollbarWidth = container.offsetWidth - inner.offsetWidth;
        document.body.removeChild(container);
        return scrollbarWidth;
    }

    /**
     * 禁止页面滚动
     */
    disableScroll() {
        const scrollbarWidth = this.getScrollbarWidth();
        document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
        document.body.classList.add('no-scroll');
    }

    /**
     * 启用页面滚动
     */
    enableScroll() {
        document.body.classList.remove('no-scroll');
        document.documentElement.style.setProperty('--scrollbar-width', '17px');
    }

    /**
     * 防抖函数
     * @param {*} func 
     * @param {*} waity 
     * @returns 
     */
    debounce(func, delay) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                func.apply(this, args)
            }, delay)
        }
    }

    /**
     * 节流函数
     * @param {*} func 
     * @param {*} delay 
     * @returns 
     */
    throttle(func, delay) {
        let lastTime = 0;
        return function (...args) {
            let nowTime = Date.now();
            if (nowTime - lastTime > delay) {
                func.apply(this, args)
                lastTime = nowTime;
            }
        }
    }
    isInViewport(el) {
        const rect = el.getBoundingClientRect();
        const isInViewport = (
            rect.top < window.innerHeight &&
            rect.bottom > 0 &&
            rect.left < window.innerWidth &&
            rect.right > 0
        );
        return isInViewport;
    }
    getDistanceFromTop(element) {
        var distance = element.offsetTop;
        var parent = element.offsetParent;
        while (parent) {
            distance += parent.offsetTop;
            parent = parent.offsetParent;
        }
        return distance;
    }

    /**
     * 容器自动滚动
     * @param {*} container
     * @param {*} target
     */
    containerAutoScoll(container,target){
        const containerWidth = container.offsetWidth;
        const tabLeft = target.offsetLeft;
        const tabWidth = target.offsetWidth;
        const scrollPosition = tabLeft + tabWidth / 2 - containerWidth / 2;
        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
    }

    /**
     * 倒计时
     * @param {*} expiry 
     * @returns 
     */
    timer(expiry) {
        return {
            expiry: expiry,
            remaining: null,
            init() {
                this.setRemaining()
                setInterval(() => {
                    this.setRemaining();
                }, 1000);
            },
            setRemaining() {
                const diff = this.expiry - new Date().getTime();
                if (diff > 0) {
                    this.remaining = parseInt(diff / 1000);
                } else {
                    this.remaining = 0;
                }
            },
            days() {
                return {
                    value: this.remaining / 86400,
                    remaining: this.remaining % 86400
                };
            },
            hours() {
                return {
                    value: this.days().remaining / 3600,
                    remaining: this.days().remaining % 3600
                };
            },
            minutes() {
                return {
                    value: this.hours().remaining / 60,
                    remaining: this.hours().remaining % 60
                };
            },
            seconds() {
                return {
                    value: this.minutes().remaining,
                };
            },
            format(value) {
                return ("0" + parseInt(value)).slice(-2)
            },
            time() {
                return {
                    days: this.format(this.days().value),
                    hours: this.format(this.hours().value),
                    minutes: this.format(this.minutes().value),
                    seconds: this.format(this.seconds().value),
                }
            },
        }
    }

    timerTz(expiry, timeZone) {
        return {
            targetTimePST: moment.tz(expiry, timeZone),
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            format(value) {
                return value < 0 ? '00' : value < 10 ? `0${value}` : value;
            },
            updateCountdown() {
                // 获取当前UTC时间
                const now = moment.utc();

                // 转换为PST时间
                const nowPST = now.tz(timeZone);

                // 计算倒计时差
                const duration = moment.duration(this.targetTimePST.diff(nowPST));

                // 格式化显示倒计时
                this.days = Math.floor(duration.asDays());
                this.hours = duration.hours();
                this.minutes = duration.minutes();
                this.seconds = duration.seconds();
            },
            init() {
                this.updateCountdown();
                setInterval(() => {
                    this.updateCountdown();
                }, 1000);
            },
            time() {
                return {
                    days: this.format(this.days),
                    hours: this.format(this.hours),
                    minutes: this.format(this.minutes),
                    seconds: this.format(this.seconds),
                };
            },
        };
    }
}

const weUtil = new WeUtil();

